import { toArray as stringzToArray } from 'stringz';

/**
 * 限制文字长度，超过制定中文字符展示宽度时候，追加省略号
 * @param nameStr 待测量文字
 * @param limit 展示长度(中文自宽，数字和英文算0.5)
 * @param replace 省略符号
 */
export function formateTextWidth(str: string, limit = 5, replace = '...'): string {
    let realLength = 0;
    const list = stringzToArray(str ?? '');
    for (let i = 0; i < list.length; i++) {
        const charCode = list[i].charCodeAt(0);
        const isAscii = charCode >= 0 && charCode <= 128;
        if (isAscii) {
            realLength += 1;
        } else {
            realLength += 2;
        }
        if (realLength > limit * 2) {
            return list.slice(0, i).join('') + replace;
        }
    }
    return str;
}
